import { Component, OnInit } from '@angular/core';
import { PuiAuthService } from '../../../core/index';

declare var Layout: any;

@Component({
  selector: 'pui-desktop',
  templateUrl: 'desktop.component.html'
})
export class PuiDesktopComponent implements OnInit {

  constructor(private authService: PuiAuthService) {}

  ngOnInit() { }
}
